<template>
  <section class="section banner --dark">
    <div class="banner__content">
      <Image :source="content.logo" class="banner__logo"/>
      <Image :source="content.title" class="banner__title"/>
      <p class="banner__keywords">
        <template v-for="(keyword, keywordIndex) in content.keywords.split(', ')" :key="`keyword-${keywordIndex}`">
          <span>{{ keyword }}</span>
          <span class="red-dot__small"/>
        </template>
      </p>
      <p class="description banner__description">{{ content.description }}</p>
      <div class="banner__stat-group">
        <BannerStat v-for="stat in content.stats" :content="stat" :key="stat.flexKey"/>
        <LangRouterLink :to="{name: ROUTES.HOME, hash: `#${HASHES.AVAILABLE_POSITIONS}`}" class="banner__stat">
          <span>{{ content.scrollLabel }}</span>
          <Icon id="arrow"/>
        </LangRouterLink>
      </div>
      <div class="banner__buttons">
        <InternalLink :content="{link: {name: ROUTES.HOME, hash: `#${HASHES.AVAILABLE_POSITIONS}`}, label: content.availablePositions}" button/>
        <VideoLink v-if="content.video?.length" :content="content.video[0]"/>
      </div>
      <img src="@/assets/patterns/words_pattern_black.jpg" alt="" class="banner__pattern">
    </div>
    <video :src="content.loop.original" class="banner__loop" autoplay muted loop/>
  </section>
</template>

<script>
import {Icon, Image, LangRouterLink} from '@/components/global'
import {BannerStat, InternalLink, VideoLink} from '@/components/small'
import {HasContentMixin, UsesRoutesMixin} from '@/mixins'

export default {
  name: 'BannerSection',
  mixins: [HasContentMixin, UsesRoutesMixin],
  components: {BannerStat, Icon, Image, InternalLink, LangRouterLink, VideoLink}
}
</script>